

const calcAnnoucementHeight = () => {
  let announcement = document.getElementById('shopify-section-announcement-bar')

  if (announcement) {
    let announcementHeight = `${announcement.getBoundingClientRect().bottom}px`
    let header = document.getElementById('shopify-section-header')

    let doc = document.documentElement;
    doc.style.setProperty('--under-announcement', announcementHeight);
  }
}

function initEqCustomMenuClose() {
  let menuIcon = document.getElementsByClassName('header__icon--menu')
  let customClose = document.getElementById('eq-custom-close-span')
  let overlay = document.getElementById('sidemenu-overlay')
  let html = document.getElementsByTagName('html')[0]

  if (menuIcon[0]) {
    menuIcon[0].addEventListener('click', () => {
        html.classList.toggle('overflow-hidden')
  
        calcAnnoucementHeight();
  
        let mobileNav = document.getElementsByClassName('mobile-nav-menu')
        if (mobileNav[0]) {
          mobileNav[0].classList.toggle('hide-mobile-nav')
        }

    })
  }

  if (customClose) {
    customClose.addEventListener('click', () => {
      
      let closeIcon = document.getElementsByClassName('header-drawer')
      if (closeIcon[0]) {
        closeIcon[0].firstElementChild.firstElementChild.click()
      }
    })
  }

  if (overlay) {
    overlay.addEventListener('click', () => {
      let closeIcon = document.getElementsByClassName('header-drawer')
      if (closeIcon[0]) {
        closeIcon[0].firstElementChild.firstElementChild.click()
      }
    })
  }
}

function initMobileMenuSwiper() {
  let mobileMenu = document.getElementsByClassName('mobile-nav-menu')
  if (mobileMenu[0]) {
    const mobileMenuSwiper = new Swiper('.mobile-nav-menu', {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      scrollbar: {
        el: '.mobile-nav-menu-scrollbar'
      }
    })

    //unhide mobile navbar until swiper effect takes place
    setTimeout(()=>{
      mobileMenu[0].style.visibility = 'unset';
    },400);
  }
}

window.addEventListener('load', () => {
  initMobileMenuSwiper()
  initEqCustomMenuClose()
  calcAnnoucementHeight()
})
